import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/apiClient';

export type StageInfo = {
  description: string;
  probability: number; // 0..1 from API
  order: number;
};

export type PipelineStagesResponse = {
  success: boolean;
  stages: string[];
  stage_info: Record<string, StageInfo>;
};

export function usePipelineStages() {
  const { data, isLoading, error } = useQuery<PipelineStagesResponse>({
    queryKey: ['pipeline-stages'],
    queryFn: () => apiClient.get('/pipeline/stages'),
    staleTime: 10 * 60 * 1000,
  });

  const stages = data?.stages ?? [];
  const stageInfo = data?.stage_info ?? {};

  return { stages, stageInfo, isLoading, error };
}
